import { useCallback, useReducer } from 'react';
import log from 'app/home/general-components/Logging';

// rooms : room_id -> {
//                        "room_id": 1,
//                        "color": 10,
//                        "name": "اتاق خواب",
//                        "avatar": 2,
//                        "device_macs": [
//                            "mac1", "mac2", "mac3"
//                        ],
//                    }


export default function useRoom(sendEvent) {
    const roomEventReducer = useCallback((currentRoomsData, event) => {
        let newRooms = {};
        let newRoomsOrder = [];
        let message = undefined;
        switch (event.source) {
            case "UserChangeOrder":
                return { rooms: currentRoomsData.rooms, roomsOrder: event.inner.room_ids }
            case "UserChange":
                return processChangeRoom(event.inner, currentRoomsData);
            case "UserRemove":
                return processRemoveRoom(event.inner.room_id, currentRoomsData);
            case "Gateway":
                message = event.inner;
                switch (message.ev) {
                    case 'room_list':
                        newRooms = {};
                        newRoomsOrder = [];
                        for (let i = 0; i < message.msg.rooms.length; i++) {
                            const room = message.msg.rooms[i];
                            newRoomsOrder.push(room.room_id);
                            newRooms[room.room_id] = room;
                        }
                        // for (let j = 1000; j < 1010; j++) {
                        //     let k = "dummy-" + String(j)
                        //     newRoomsOrder.push(k);
                        //     newRooms[k] = {room_id: k, name: "x", color: 1, avatar: 2, device_macs: []};
                        // }
                        return { rooms: newRooms, roomsOrder: newRoomsOrder }
                    case 'change_room':
                        return processChangeRoom(message.msg, currentRoomsData);
                    case 'new_room':
                        return processNewRoom(message.msg, currentRoomsData);
                    case 'remove_room':
                        return processRemoveRoom(message.msg.room_id, currentRoomsData);
                    case 'change_room_order':
                        return { rooms: currentRoomsData.rooms, roomsOrder: message.msg.room_ids }
                    default:
                        log('unsupported event in roomEventReducer:Gateway,', message.ev);
                        break;
                }
                break
            default:
                log('unsupported event in roomEventReducer,', event);
                break;
        }
    }, []);

    const [roomsData, dispatchRoomEvent] = useReducer(roomEventReducer, { rooms: {}, roomsOrder: [] });

    const changeOrder = useCallback((newOrder) => {
        dispatchRoomEvent({
            source: "UserChangeOrder",
            inner: {
                room_ids: newOrder,
            }
        });
        sendEvent("change_room_order", { "room_ids": newOrder })
    }, [sendEvent]);
    const changeRoom = useCallback((message) => {
        dispatchRoomEvent({
            source: "UserChange",
            inner: message
            // message is: {
            //     "room_id": 1,
            //
            //     "color": 10,
            //     "name": "اتاق خواب",
            //     "avatar": 2,
            //     "device_macs": [
            //         "mac1", "mac2", "mac3"
            //     ],
            // }
        });
        sendEvent("change_room", message)
    }, [sendEvent]);
    const removeRoom = useCallback((roomId) => {
        dispatchRoomEvent({
            source: "UserRemove",
            inner: {
                room_id: roomId,
            }
        });
        sendEvent("remove_room", { "room_id": roomId })
    }, [sendEvent]);
    const newRoom = useCallback((roomData) => {
        sendEvent("new_room", roomData)
    }, [sendEvent]);

    const onRoomRelatedEvent = useCallback((message) => {
        dispatchRoomEvent({ source: "Gateway", inner: message });
    }, []);

    return {
        onRoomRelatedEvent,
        roomsData,
        roomsController: {
            changeOrder,
            changeRoom, removeRoom, newRoom
        }
    }
}

function processChangeRoom(data, currentRoomsData) {
    let newRooms = { ...currentRoomsData.rooms };
    if (data.room_id in newRooms) {
        if (data.device_macs !== undefined) {
            for (const rid in newRooms) { // for rooms
                let r = { ...newRooms[rid] }
                r.device_macs = [...r.device_macs]
                for (let i = 0; i < data.device_macs.length; i++) {  // for new devices
                    const m = data.device_macs[i];

                    const m_index_in_r = r.device_macs.findIndex((x) => x === m);
                    if (m_index_in_r >= 0) {
                        r.device_macs.splice(m_index_in_r, 1); // remove the device from the room
                    }
                }
                newRooms[rid] = r;
            }
        }

        let room = { ...newRooms[data.room_id] }
        if (data.color !== undefined) {
            room["color"] = data.color;
        }
        if (data.name !== undefined) {
            room["name"] = data.name;
        }
        if (data.avatar !== undefined) {
            room["avatar"] = data.avatar;
        }
        if (data.device_macs !== undefined) {
            room["device_macs"] = data.device_macs;
        }
        newRooms[data.room_id] = room;
    }
    return { rooms: newRooms, roomsOrder: currentRoomsData.roomsOrder }
}

function processRemoveRoom(roomId, currentRoomsData) {
    let newRooms = { ...currentRoomsData.rooms };
    let newRoomsOrder = [...currentRoomsData.roomsOrder];
    if (roomId in newRooms) {
        delete newRooms[roomId];
        newRoomsOrder = newRoomsOrder.filter((item) => { return item !== roomId })
    }
    return { rooms: newRooms, roomsOrder: newRoomsOrder }
}

function processNewRoom(room, currentRoomsData) {
    let newRooms = { ...currentRoomsData.rooms };
    let newRoomsOrder = [...currentRoomsData.roomsOrder];

    for (const rid in newRooms) { // for rooms
        let r = { ...newRooms[rid] }
        r.device_macs = [...r.device_macs]
        for (let i = 0; i < room.device_macs.length; i++) {  // for new devices
            const m = room.device_macs[i];

            const m_index_in_r = r.device_macs.findIndex((x) => x === m);
            if (m_index_in_r >= 0) {
                r.device_macs.splice(m_index_in_r, 1); // remove the device from the room
            }
        }
        newRooms[rid] = r;
    }

    newRooms[room.room_id] = room;
    newRoomsOrder.push(room.room_id);
    return { rooms: newRooms, roomsOrder: newRoomsOrder }
}

